/* Seoulogy navigation system — scoped, dependency-free.
   Handles: desktop mega menus (hover intent + click + keyboard),
   overlay, brand story panel, mobile drawer (focus trap + scroll lock),
   search bar proxy to Dawn's search modal, popular search chips. */
(function () {
  'use strict';
  if (window.__sgyNavInit) return;
  window.__sgyNavInit = true;

  var HOVER_OPEN_MS = 350;
  var HOVER_CLOSE_MS = 420;
  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var navRow = document.getElementById('sgyNavRow');
    var overlay = document.getElementById('sgyOverlay');
    var header = document.querySelector('.section-header') || document.querySelector('header.header');

    /* ---------------- Desktop mega menus ---------------- */
    var triggers = [].slice.call(document.querySelectorAll('.sgy-navlink[data-sgy-mega]'));
    var panels = {};
    triggers.forEach(function (btn) {
      var id = btn.getAttribute('aria-controls');
      var panel = id ? document.getElementById(id) : null;
      if (panel) panels[btn.getAttribute('data-sgy-mega')] = { btn: btn, panel: panel };
    });

    var openKey = null;
    var openTimer = null;
    var closeTimer = null;

    function setOverlay(on) {
      if (!overlay) return;
      overlay.classList.toggle('on', !!on);
    }

    function closeMega(immediate) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (!openKey) return;
      var entry = panels[openKey];
      openKey = null;
      if (entry) {
        entry.panel.classList.remove('open');
        entry.btn.setAttribute('aria-expanded', 'false');
        entry.btn.classList.remove('is-active') /*noop*/;
      }
      setOverlay(false);
    }

    function openMega(key) {
      if (openKey === key) return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (openKey && panels[openKey]) {
        panels[openKey].panel.classList.remove('open');
        panels[openKey].btn.setAttribute('aria-expanded', 'false');
        panels[openKey].btn.classList.remove('is-active') /*noop*/;
      }
      var entry = panels[key];
      if (!entry) { openKey = null; setOverlay(false); return; }
      openKey = key;
      entry.panel.classList.add('open');
      entry.btn.setAttribute('aria-expanded', 'true');
      entry.btn.classList.add('is-active');
      setOverlay(true);
    }

    Object.keys(panels).forEach(function (key) {
      var entry = panels[key];

      /* Hover intent (mouse only) */
      entry.btn.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { openMega(key); }, openKey ? 60 : HOVER_OPEN_MS);
      });
      entry.btn.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { closeMega(); }, HOVER_CLOSE_MS);
      });
      entry.panel.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
      entry.panel.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { closeMega(); }, HOVER_CLOSE_MS);
      });

      /* Click / keyboard toggle */
      entry.btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        clearTimeout(openTimer);
        if (openKey === key) { closeMega(); } else { openMega(key); }
      });
      entry.btn.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowDown' || ev.key === 'Enter' || ev.key === ' ') {
          if (ev.key === 'ArrowDown') {
            ev.preventDefault();
            openMega(key);
            var first = entry.panel.querySelector('a, button');
            if (first) first.focus();
          }
        }
      });
    });

    /* Escape + click outside + focus-out */
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') {
        if (openKey) {
          var btn = panels[openKey] && panels[openKey].btn;
          closeMega();
          if (btn) btn.focus();
        }
        closeDrawer();
      }
    });
    document.addEventListener('click', function (ev) {
      if (!openKey) return;
      var entry = panels[openKey];
      if (!entry) return;
      if (entry.panel.contains(ev.target) || entry.btn.contains(ev.target)) return;
      closeMega();
    });
    document.addEventListener('focusin', function (ev) {
      if (!openKey) return;
      var entry = panels[openKey];
      if (!entry) return;
      if (entry.panel.contains(ev.target) || entry.btn.contains(ev.target)) return;
      if (navRow && navRow.contains(ev.target)) { closeMega(); return; }
      closeMega();
    });
    if (overlay) overlay.addEventListener('click', function () { closeMega(); });

    /* Close on resize into mobile */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      var w = window.innerWidth;
      if (w !== lastW) {
        lastW = w;
        closeMega(true);
        if (w > 989) closeDrawer();
      }
    });

    /* ---------------- Brand story panel ---------------- */
    var bList = document.getElementById('sgyBrandList');
    var bPanel = document.getElementById('sgyBrandPanel');
    if (bList && bPanel) {
      var bButtons = [].slice.call(bList.querySelectorAll('.sgy-blist button'));
      var fields = {
        name: bPanel.querySelector('[data-b-name]'),
        origin: bPanel.querySelector('[data-b-origin]'),
        story: bPanel.querySelector('[data-b-story]'),
        best: bPanel.querySelector('[data-b-best]'),
        shop: bPanel.querySelector('[data-b-shop]'),
        read: bPanel.querySelector('[data-b-read]'),
        img: bPanel.querySelector('[data-b-img]')
      };
      function selectBrand(btn, focusPanel) {
        bButtons.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        var d = btn.dataset;
        if (fields.name) fields.name.textContent = d.name || '';
        if (fields.origin) fields.origin.textContent = d.origin || '';
        if (fields.story) fields.story.textContent = d.story || '';
        if (fields.best) fields.best.textContent = d.best || '';
        if (fields.shop) {
          fields.shop.href = d.shop || '#';
          fields.shop.setAttribute('aria-label', 'Shop ' + (d.name || 'brand'));
        }
        if (fields.read) {
          fields.read.href = d.read || '#';
          fields.read.setAttribute('aria-label', 'Read the ' + (d.name || 'brand') + ' story');
        }
        if (fields.img) {
          if (d.img) {
            fields.img.src = d.img;
            fields.img.alt = d.name || '';
            fields.img.hidden = false;
          } else {
            fields.img.hidden = true;
          }
        }
        if (!reduceMotion) {
          bPanel.classList.remove('sgy-bpanel--swap');
          void bPanel.offsetWidth; /* restart animation */
          bPanel.classList.add('sgy-bpanel--swap');
        }
      }
      bButtons.forEach(function (btn, i) {
        var hoverT = null;
        btn.addEventListener('mouseenter', function () {
          clearTimeout(hoverT);
          hoverT = setTimeout(function () { selectBrand(btn); }, 120);
        });
        btn.addEventListener('mouseleave', function () { clearTimeout(hoverT); });
        btn.addEventListener('click', function () { selectBrand(btn); });
        btn.addEventListener('focus', function () { selectBrand(btn); });
        btn.addEventListener('keydown', function (ev) {
          var next = null;
          if (ev.key === 'ArrowDown') next = bButtons[i + 1] || bButtons[0];
          if (ev.key === 'ArrowUp') next = bButtons[i - 1] || bButtons[bButtons.length - 1];
          if (next) { ev.preventDefault(); next.focus(); }
        });
      });
      if (bButtons.length) selectBrand(bButtons[0]);
    }

    /* ---------------- Search bar proxy ---------------- */
    var searchbar = document.getElementById('sgySearchbar');
    if (searchbar) {
      searchbar.addEventListener('click', function () {
        closeMega();
        var modal = header ? header.querySelector('details-modal.header__search') : document.querySelector('details-modal.header__search');
        if (!modal) return;
        var details = modal.querySelector('details');
        var summary = modal.querySelector('summary');
        if (summary && details && !details.hasAttribute('open')) {
          summary.click();
        }
        setTimeout(function () {
          var input = modal.querySelector('input[type="search"]');
          if (input) input.focus();
        }, 60);
      });
    }

    /* Popular search chips inside Dawn's search modal */
    (function () {
      var host = document.querySelector('details-modal.header__search .search-modal__form, details-modal.header__search form');
      var dataEl = document.getElementById('sgyPopularData');
      if (!host || !dataEl) return;
      var terms = [];
      try { terms = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }
      terms = terms.map(function (t) { return String(t).trim(); }).filter(Boolean);
      if (!terms.length) return;
      if (document.getElementById('sgyPopular')) return;
      var wrap = document.createElement('div');
      wrap.className = 'sgy-popular';
      wrap.id = 'sgyPopular';
      var label = document.createElement('span');
      label.className = 'lbl';
      label.textContent = 'Popular:';
      wrap.appendChild(label);
      terms.forEach(function (t) {
        var a = document.createElement('a');
        a.href = '/search?q=' + encodeURIComponent(t);
        a.textContent = t;
        wrap.appendChild(a);
      });
      var form = host.closest('form') || host;
      form.parentNode.insertBefore(wrap, form.nextSibling);
    })();

    /* ---------------- Mobile drawer ---------------- */
    var burger = document.getElementById('sgyBurger');
    var drawer = document.getElementById('sgyMnav');
    var mOverlay = document.getElementById('sgyMoverlay');
    var drawerOpen = false;
    var lastFocus = null;

    function focusables(root) {
      return [].slice.call(root.querySelectorAll(
        'a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }

    function openDrawer() {
      if (!drawer || drawerOpen) return;
      drawerOpen = true;
      lastFocus = document.activeElement;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      if (mOverlay) mOverlay.classList.add('on');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sgy-lock');
      var f = focusables(drawer);
      if (f.length) f[0].focus();
    }

    function closeDrawer() {
      if (!drawer || !drawerOpen) return;
      drawerOpen = false;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      if (mOverlay) mOverlay.classList.remove('on');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sgy-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (burger && drawer) {
      burger.addEventListener('click', function () {
        if (drawerOpen) { closeDrawer(); } else { openDrawer(); }
      });
      var closeBtn = drawer.querySelector('.sgy-mnav__close');
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (mOverlay) mOverlay.addEventListener('click', closeDrawer);

      /* Focus trap */
      drawer.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Tab' || !drawerOpen) return;
        var f = focusables(drawer);
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === first) {
          ev.preventDefault(); last.focus();
        } else if (!ev.shiftKey && document.activeElement === last) {
          ev.preventDefault(); first.focus();
        }
      });

      /* Mobile search trigger inside drawer */
      var mSearch = drawer.querySelector('.sgy-mnav__search');
      if (mSearch) {
        mSearch.addEventListener('click', function () {
          closeDrawer();
          if (searchbar) { searchbar.click(); return; }
          var summary = document.querySelector('details-modal.header__search summary');
          if (summary) summary.click();
        });
      }
    }
  });
})();
